import React, { useContext, useEffect, useState } from "react";

import "./stylesTransactionsTable.css";

import Layout from "../../CommonComponents/Layout/Layout";
import { SIDER_TABS } from "../../../utils/Constants";
import AppContext from "../../../context/AppContext";
import CustomDatePicker from "../../CommonComponents/CustomDatePicker/CustomDatePicker";

import dayjs from "dayjs";

import { Input, Select, Table } from "antd";
import CustomAutoComplete from "../../CommonComponents/CustomAutoComplete/CustomAutoComplete";
import { Filter, ChevronUp, ChevronDown } from "react-feather";
import {
  VerticalAlignBottomOutlined,
  VerticalAlignTopOutlined,
} from "@ant-design/icons";

import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";
import {
  states,
  getStateNameByAbbreviation,
} from "../../../utils/MapStateName";
import SaveButton from "../../CommonComponents/SaveButton/SaveButton";
import RebetLoader from "../../CommonComponents/RebetLoader/RebetLoader";

const type = [
  {
    value: "",
    label: "Not Selected",
  },
  {
    value: "deposit",
    label: "Deposit",
  },
  {
    value: "withdraw",
    label: "Withdraw",
  },
];

const status = [
  {
    value: "",
    label: "Not Selected",
  },
  {
    value: "Pending",
    label: "Pending",
  },
  {
    value: "Approved",
    label: "Approved",
  },
];

const platform = [
  {
    value: "",
    label: "Not Selected",
  },
  {
    value: "nmi",
    label: "NMI",
  },
  {
    value: "finix",
    label: "Finix",
  },
];

const state = Object.keys(states).map((abbr) => {
  return (
    {
      value: "",
      label: "Not Selected",
    },
    {
      value: states[abbr],
      label: states[abbr],
      abbr: abbr,
    }
  );
});

const amount = [
  {
    value: "",
    label: "Not Selected",
  },
  {
    value: "5000",
    label: "1000-5000",
  },
  {
    value: "10000",
    label: "5000-10000",
  },
];

const columns = [
  {
    title: "ID",
    dataIndex: "player",
    key: "player",
    width: 250,
  },
  // {
  //   title: "Player",
  //   dataIndex: "player",
  //   key: "player",
  //   width: 250,
  //   render: (player, record) => {
  //     return (
  //       <div className="player-container">
  //         <span>{player}</span>
  //         {record.requiresAction && <img src={AlertIcon} alt="alert icon" />}
  //       </div>
  //     );
  //   },
  // },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    width: 150,
    sorter: (a, b) => a.amount - b.amount,
    render: (amount) => {
      return (
        <span className={amount < 0 ? "negative-amount" : "positive-amount"}>
          {Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
          }).format(amount)}
        </span>
      );
    },
  },
  // {
  //   title: "Fee",
  //   dataIndex: "fee",
  //   key: "fee",
  //   width: 150,
  //   render: (fee) => {
  //     return (
  //       <span>
  //         {Intl.NumberFormat("en-US", {
  //           style: "currency",
  //           currency: "USD",
  //           minimumFractionDigits: 2,
  //         }).format(fee)}
  //       </span>
  //     );
  //   },
  // },
  // {
  //   title: "Sales Tax",
  //   dataIndex: "salesTax",
  //   key: "salesTax",
  //   width: 150,
  //   render: (salesTax) => {
  //     return (
  //       <span>
  //         {Intl.NumberFormat("en-US", {
  //           style: "currency",
  //           currency: "USD",
  //           minimumFractionDigits: 2,
  //         }).format(salesTax)}
  //       </span>
  //     );
  //   },
  // },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    width: 150,
    render: (type) => {
      return (
        <div className="transaction-type-container">
          {type === "Deposit" ? (
            <VerticalAlignBottomOutlined />
          ) : (
            <VerticalAlignTopOutlined />
          )}
          <span>{type}</span>
        </div>
      );
    },
  },
  {
    title: "Platform",
    dataIndex: "platform",
    key: "platform",
    width: 150,
    render: (platform) => {
      return <span>{platform}</span>;
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: 150,
    render: (status) => {
      return (
        <span className={`status ${status.split(" ").join("-").toLowerCase()}`}>
          {status}
        </span>
      );
    },
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    width: 150,
    render: (date) => {
      return <span>{dayjs(date).format("MM/DD/YYYY")}</span>;
    },
  },
  {
    title: "State",
    dataIndex: "state",
    key: "state",
    width: 150,
    render: (state) => {
      return <span>{getStateNameByAbbreviation(state)}</span>;
    },
  },
  // {
  //   title: "Fraud Type",
  //   dataIndex: "fraudType",
  //   key: "fraudType",
  //   width: 150,
  // },
  // {
  //   title: "Fraud Note",
  //   dataIndex: "fraudNote",
  //   key: "fraudNote",
  //   width: 250,
  // },
];

function TransactionsTable() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );
  const { setActiveSidebarTab } = useContext(AppContext);

  const thisMonthRange = [dayjs().startOf("month"), dayjs().endOf("month")];

  const [isApiRunning, setIsApiRunning] = useState(false);
  const [transactionsOverviewDates, setTransactionsOverviewDates] =
    useState(thisMonthRange);

  const [showExtraFilters, setShowExtraFilters] = useState(false);
  const [activeTab, setActiveTab] = useState("All transactions");

  const [data, setData] = useState([]);
  const [dataToShow, setDataToShow] = useState(data);
  const [pagination, setPagination] = useState({
    current_page: 1,
    page_size: 50,
    total_results: 0,
    total_pages: 0,
    has_next: false,
    has_prev: false,
  });
  const [transactionsTableFilters, setTransactionsTableFilters] = useState({
    user_id: "",
    type: "",
    status: "",
    platform: "",
    state: "",
    amount: "",
  });

  const getTransactionsOverviewData = async (
    queryString = thisMonthRange,
    isQueryString = true
  ) => {
    setIsApiRunning(true);

    let startDate = "";
    let endDate = "";

    if (isQueryString) {
      let formattedQueryString = queryString.split("&");
      startDate = dayjs(formattedQueryString[0]).format("YYYY-MM-DD");
      endDate = dayjs(formattedQueryString[1]).format("YYYY-MM-DD");
    } else {
      startDate = queryString[0]?.format("YYYY-MM-DD");
      endDate = queryString[1]?.format("YYYY-MM-DD");
    }

    if (startDate === endDate) {
      endDate = dayjs(endDate).add(1, "day").format("YYYY-MM-DD");
    }

    const params = {
      start_date: startDate,
      end_date: endDate,
      ...transactionsTableFilters,
      amount: { operator: "lte", value: transactionsTableFilters.amount },
    };

    console.log("params", params);

    try {
      const requests = [
        PrivateAdminPanelInstance?.post(
          API_ROUTES?.GET_WALLET_TRANSACTIONS_TABLE,
          params
        ),
      ];

      const response = await Promise.allSettled(requests);

      const [walletTransactionsTableResponse] = response;

      if (walletTransactionsTableResponse.status === "fulfilled") {
        const walletTransactionsTableData =
          walletTransactionsTableResponse?.value?.data?.data;
        console.log("walletTransactionsTableData", walletTransactionsTableData);
        setData(walletTransactionsTableData.transactions);
        setPagination(walletTransactionsTableData.pagination);
      }
    } catch (error) {
      console.log("Error fetching wallet transactions", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.TRANSACTIONS, "Reports");
  }, [setActiveSidebarTab]);

  useEffect(() => {
    getTransactionsOverviewData(thisMonthRange, false);
  }, []);

  useEffect(() => {
    setDataToShow(data);
  }, [data]);

  const loadMoreTransactions = async (
    pageParam = pagination.current_page + 1
  ) => {
    setIsApiRunning(true);

    let startDate = dayjs(transactionsOverviewDates[0]).format("YYYY-MM-DD");
    let endDate = dayjs(transactionsOverviewDates[1]).format("YYYY-MM-DD");
    const page = pageParam;

    if (startDate === endDate) {
      endDate = dayjs(endDate).add(1, "day").format("YYYY-MM-DD");
    }

    const params = {
      page: page,
      start_date: startDate,
      end_date: endDate,
      ...transactionsTableFilters,
      amount: { operator: "lte", value: transactionsTableFilters.amount },
    };

    console.log("params", params);

    try {
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_WALLET_TRANSACTIONS_TABLE,
        params
      );

      const walletTransactionsTableData = response?.data?.data;
      if (page === 1) {
        setData(walletTransactionsTableData.transactions);
      } else {
        setData([...data, ...walletTransactionsTableData.transactions]);
      }
      setPagination(walletTransactionsTableData.pagination);
    } catch (error) {
      console.log("Error fetching wallet transactions", error);
    } finally {
      setIsApiRunning(false);
    }
  };
  return (
    <Layout name={SIDER_TABS.TRANSACTIONS}>
      <div className="transactions-overview-container">
        <div className="transactions-overview-header">
          <h2 className="transactions-overview-title">Reports</h2>
          <CustomDatePicker
            getData={getTransactionsOverviewData}
            dates={transactionsOverviewDates}
            setDates={setTransactionsOverviewDates}
            showPresets={true}
            startRange="This Week"
          />
        </div>

        <div className="transactions-overview-content">
          <div className="transactions-overview-table-container">
            <div className="transactions-overview-table-header">
              <h2>Transactions</h2>
            </div>
            <div className="transactions-overview-table-search-container">
              <div className="transactions-overview-autocomplete-container">
                <div className="transactions-overview-selectors search-by-id-selector">
                  <div className="transactions-overview-selector">
                    <Select
                      placeholder="Search by ID"
                      value={"Search by ID"}
                      options={[
                        {
                          id: "Search by ID",
                          value: "Search by ID",
                        },
                      ]}
                    />
                  </div>
                </div>

                <Input
                  placeholder="Search"
                  value={transactionsTableFilters.user_id}
                  onChange={(e) => {
                    setTransactionsTableFilters({
                      ...transactionsTableFilters,
                      user_id: e.target.value,
                    });
                  }}
                />
                <div className="divider"></div>
                <div
                  className="filter-buttons"
                  onClick={() => setShowExtraFilters(!showExtraFilters)}
                >
                  <Filter className="filter-icon" />
                  {showExtraFilters ? (
                    <ChevronUp className="filter-icon" />
                  ) : (
                    <ChevronDown className="filter-icon" />
                  )}
                </div>
              </div>
            </div>
            <div
              className="transactions-overview-selectors"
              style={{ display: showExtraFilters ? "flex" : "none" }}
            >
              <div className="transactions-overview-selector">
                <span>Type</span>
                <Select
                  placeholder="Not Selected"
                  value={transactionsTableFilters.type}
                  onChange={(values) => {
                    setTransactionsTableFilters({
                      ...transactionsTableFilters,
                      type: values,
                    });
                  }}
                  options={type}
                />
              </div>
              <div className="transactions-overview-selector">
                <span>Status</span>
                <Select
                  placeholder="Not Selected"
                  value={transactionsTableFilters.status}
                  onChange={(values) => {
                    setTransactionsTableFilters({
                      ...transactionsTableFilters,
                      status: values,
                    });
                  }}
                  options={status}
                />
              </div>
              <div className="transactions-overview-selector">
                <span>Platform</span>
                <Select
                  placeholder="Not Selected"
                  value={transactionsTableFilters.platform}
                  onChange={(values) => {
                    setTransactionsTableFilters({
                      ...transactionsTableFilters,
                      platform: values,
                    });
                  }}
                  options={platform}
                />
              </div>
              <div className="transactions-overview-selector">
                <span>State</span>
                <CustomAutoComplete
                  placeholder="Not Selected"
                  value={transactionsTableFilters.state}
                  handleChange={(values) => {
                    setTransactionsTableFilters({
                      ...transactionsTableFilters,
                      state: values,
                    });
                  }}
                  selector="abbr"
                  allOptions={state}
                  clearOptions={() => {
                    setTransactionsTableFilters({
                      ...transactionsTableFilters,
                      state: "",
                    });
                  }}
                />
              </div>
            </div>
            <div
              className="transactions-overview-selectors"
              style={{ display: showExtraFilters ? "flex" : "none" }}
            >
              <div className="transactions-overview-selector">
                <span>Amount</span>
                <Select
                  placeholder="Not Selected"
                  value={transactionsTableFilters.amount}
                  onChange={(values) => {
                    console.log("values", values);
                    setTransactionsTableFilters({
                      ...transactionsTableFilters,
                      amount: values,
                    });
                  }}
                  options={amount}
                />
              </div>
            </div>
            <div className="transactions-overview-selector-action-buttons">
              <button
                className="clear"
                onClick={() => {
                  setTransactionsTableFilters({
                    user_id: "",
                    type: "",
                    status: "",
                    platform: "",
                    state: "",
                    amount: "",
                  });
                }}
              >
                Clear Filters
              </button>
              <button
                className="apply"
                onClick={() => {
                  loadMoreTransactions(1);
                }}
              >
                Apply
              </button>
            </div>

            <div className="transactions-overview-table-container-table">
              {isApiRunning ? (
                <div className="transactions-overview-table-container-table-loading">
                  <RebetLoader width={100} height={100} />
                </div>
              ) : (
                <>
                  <div className="transactions-overview-table-container-table-tabs">
                    <div
                      className={`transactions-overview-table-container-table-tab ${
                        activeTab === "All transactions" ? "active" : ""
                      }`}
                      onClick={() => {
                        setActiveTab("All transactions");
                        setDataToShow(data);
                      }}
                    >
                      All transactions
                    </div>
                    <div
                      className={`transactions-overview-table-container-table-tab ${
                        activeTab === "Action required" ? "active" : ""
                      }`}
                      onClick={() => {
                        setActiveTab("Action required");
                        setDataToShow([]);
                      }}
                    >
                      Action required
                    </div>
                  </div>

                  <Table
                    columns={columns}
                    dataSource={dataToShow}
                    scroll={{ x: 1800, y: 400 }}
                    pagination={false}
                    rowKey={(record, index) => `${record.id}-${index}`}
                  />
                  {pagination.has_next && (
                    <div className="manual-entries-table-load-more-button-container">
                      <SaveButton
                        buttonText="Load More"
                        callbackFunction={() =>
                          loadMoreTransactions(pagination.current_page + 1)
                        }
                        isApiRunning={isApiRunning}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default TransactionsTable;
